import "./internal.js";
import { initDOMManipulation } from "./lib/dom-manipulation";
import { initScroll } from "./lib/scroll";
import { initAccordion } from "./lib/accordion";
import BetterMenu from "./lib/better-menu/better-menu";
import BetterModal from "./lib/better-menu/better-modal";
import "./components/search.js";

document.addEventListener("DOMContentLoaded", function () {
	document.querySelector("body").setAttribute("data-s-loaded", "");
	initDOMManipulation();
	initScroll();
	initAccordion();

	new BetterMenu();
	new BetterModal();
	// Search form is self-initializing in its own module
});
